import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MarketService } from "../../../../../../../shared/src/lib/services/market.service";
import { AsyncPipe, DatePipe } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RouterLink } from "@angular/router";
import { AlertComponent } from "../../../../components/alert/alert.component";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "../../../../../../../shared/src/lib/services/loader.service";
import { combineLatest, Observable, Subject } from "rxjs";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { NhrLoaderComponent } from "./nhr-loader/nhr-loader.component";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { map, takeUntil } from "rxjs/operators";
import { NextEventsService } from "./next-events.service";

@Component({
  selector: "app-next-horse-race",
  imports: [DatePipe, MatProgressBarModule, RouterLink, AlertComponent, TranslateModule, NgxSkeletonLoaderModule, NhrLoaderComponent, AsyncPipe],
  templateUrl: "./next-horse-race.component.html",
  styleUrl: "./next-horse-race.component.scss",
})
export class NextHorseRaceComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  marketService = inject(MarketService);
  loader = inject(LoaderService);
  $loading!: Observable<boolean>;
  nextRaces: any[] = [];
  titleRace: any;
  navService = inject(NavService);
  nextEventsService = inject(NextEventsService);

  ngOnInit() {
    this.$loading = combineLatest([this.loader.isLoading("/bf/next-race"), this.loader.isLoading("/v1/api/navigation_list")]).pipe(
      map(([loadingMarkets, loadingNavigationList]) => !this.titleRace && (loadingMarkets || loadingNavigationList)),
    );
    this.nextEventsService.triggerFetch();
    this.getNextHorseRaces();
  }

  getNextHorseRaces() {
    combineLatest([this.nextEventsService.titleRace$, this.nextEventsService.comingUpRaces$])
      .pipe(
        map(([title, comingUp]) => {
          // console.log(title, comingUp);
          this.titleRace = title;
          this.nextRaces = comingUp;
        }),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
